import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormGroupDirective } from "@angular/forms";
import { FormGroup, FormText } from "@coso/forms";
import { BehaviorSubject } from "rxjs";
import { ISiteCollectionDistribution, Period, PeriodName, PeriodSource, PeriodSourceName, SiteCollectionRule, SiteCollectionRuleName } from "../../../../models/auto-generated";
import { Constants } from "../../constants";

@Component({
  standalone:false,
  templateUrl: "./site-collection-settings.component.html",
  styleUrls: ["./site-collection-settings.component.scss"]
})
export class SiteCollectionSettingsComponent implements OnInit {
  @ViewChild("namingRulePopover", { static: true }) namingRulePopover: TemplateRef<any>;
  @ViewChild("periodPopover", { static: true }) periodPopover: TemplateRef<any>;
  @ViewChild("periodSourcePopover", { static: true }) periodSourcePopover: TemplateRef<any>;
  SiteCollectionRule = SiteCollectionRule;
  Constants = Constants;
  PeriodSource = PeriodSource;
  Period = Period;
  formGroup: FormGroup<ISiteCollectionDistribution>;
  formText: FormText<ISiteCollectionDistribution>;
  isReadOnly = new BehaviorSubject<boolean>(false);

  get isReadOnly$() {
    return this.isReadOnly.asObservable();
  }

  constructor(private rootFormGroupDirective: FormGroupDirective) 
    {}

  ngOnInit(): void {
    this.formGroup = this.rootFormGroupDirective.control.get("siteCollectionDistribution") as FormGroup<ISiteCollectionDistribution>;
    this.formText = {
      pattern: {
        label: "Site Collection Naming Rule",
        labelClass: "col-lg-3",
        inputContainerClass: "col-lg-5",
        popover: this.namingRulePopover,
        options: Object.keys(SiteCollectionRule)
          .filter((k) => isNaN(Number(k)))
          .map((k) => ({ label: SiteCollectionRuleName.get(SiteCollectionRule[k]), value: SiteCollectionRule[k] }))
      },
      period: {
        label: "Period",
        labelClass: "col-lg-3",
        inputContainerClass: "col-lg-5",
        popover: this.periodPopover,
        options: [
          { label: "Select a period", value: null, disabled: true },
          ...Object.keys(Period).filter((k) => isNaN(Number(k))).map((k) => ({ label: PeriodName.get(Period[k]), value: Period[k] }))
        ],
        errors: {
          required: "The Period field is required."
        }
      },
      periodSource: {
        label: "Period Data Source",
        labelClass: "col-lg-3",
        inputContainerClass: "col-lg-5",
        popover: this.periodSourcePopover,
        options: Object.keys(PeriodSource)
          .filter((k) => isNaN(Number(k)))
          .map((k) => ({ label: PeriodSourceName.get(PeriodSource[k]), value: PeriodSource[k] }))
      },
      namePattern: {
        label: "Site Collection Name",
        labelClass: "col-lg-3",
        inputContainerClass: "col-lg-5",
        popover: "The name of the site collection to be created. The following placeholders can be used: {0} for entity name and {1} for date and time.",
        errors: {
          required: "The Site Collection Name field is required."
        }
      }
    };
  }
}
